import { StyleSheet } from 'aphrodite'
import { Common } from 'styles'

const styles = StyleSheet.create({
  banner: {
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    backgroundSize: 'cover',
    width: '100%',
    height: Common.bannerHeight,
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  bannerBlock: {
    background: 'rgba(0,0,0, 0.4)',
    color: '#fff',
    padding: '20px',
    width: '40%',
    maxWidth: '600px',
    minWidth: '300px'
  },
  bannerHeadline: {
    margin: 0,
    fontWeight: '900'
  },
  bannerText: {
    margin: 0,
    marginBottom: '20px'
  },
  bannerButton: {
    padding: 15,
    fontSize: 14,
    fontWeight: 'bold',
    background: 'rgba(0,0,0, 0.5)',
    cursor: 'pointer',
    display: 'inline-flex',
    alignSelf: 'flex-start',
    textAlign: 'center',
    ':hover': {
      background: '#000'
    }
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/StartPage/Banner/styles.js